<!-- <template>
    <div class="my-3">
        <div class="row justify-content-center">
            <div v-for="(button, index) in buttons" :key="index" class="col-auto">
                <button @click="button.action" :class="button.class">
                    <i :class="button.icon"></i> {{ button.label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionButtonsCard",
    props: {
        buttons: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>
 -->
<template>
    <div class="my-3">
        <div class="row justify-content-center">
            <slot> <!-- Permet de personnaliser les boutons si besoin -->
                <div v-for="(button, index) in buttons" :key="index" class="col-auto">
                    <button @click="button.action" :class="button.class"
                     v-if="!button.condition || button.condition()">
                        <i :class="button.icon"></i> {{ button.label }}
                    </button>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionButtonsCard",
    props: {
        buttons: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>
